/** Phân quyền — menu mã vận đơn (hãng VC thứ 3 + đơn sàn). */
export const MA_VAN_DON_PERMISSION_CODES = {
  WEB_BH_MA_VAN_DON_LIST: 'WEB_BH_MA_VAN_DON_LIST',
} as const

export type MaVanDonPermissionCode =
  (typeof MA_VAN_DON_PERMISSION_CODES)[keyof typeof MA_VAN_DON_PERMISSION_CODES]
